export const containers = {
  title: 'Containers',
  resourceName: 'Container',
  listTitle: 'Container management',
  titles: {
    view: 'Container details',
    show: 'View container',
    edit: 'Edit container',
    create: 'Create container',
    list: 'Container list',
    addQuick: 'Add quick',
  },
  messages: {
    noData: 'No data',
    totalContainers: 'Total: {total} containers',
    updateSuccess: 'Container updated successfully',
    createSuccess: 'Container created successfully',
    errorGeneric: 'An error occurred',
    savedSuccess: 'Saved successfully',
    saving: 'Saving...',
    empty: 'Empty',
    emptyNotes: 'No notes',
    emptyShippingLine: 'No shipping line',
    emptyShippingName: 'No shipping name',
    emptyProductType: 'No product type',
    emptyCustomerName: 'No customer name',
    emptyCompanyName: 'No company name',
    emptyAgency: 'No agency',
    emptySealCn: 'No seal CN',
    emptyDate: 'No date',
    selectShipments: 'Select shipments to load into container',
    selectShipmentsTooltip:
      'Only batches with complete dimensional information (length, width, height, weight) can be placed.',
    theSelectedShipments: 'The selected shipments',
    sortShipments: 'Sort shipments',
    selectAndRemoveFromContainer: 'Select and remove from container',
  },
  filter: {
    placeholder: 'Search by container code, reference code...',
    advancedFilter: 'Advanced filter',
    code: 'Container code',
    refCode: 'Reference code',
    status: 'Status',
    clearFilter: 'Clear filter',
    search: 'Search',
    all: 'All',
  },
  validation: {
    refCodeRequired: 'Please enter reference code',
    selectFromToWarehouse: 'Please select from warehouse and to warehouse',
    checkDates: 'Please check departure, arrival and return dates',
    departureBeforeArrival: 'Departure date must be before or equal to arrival date',
    arrivalBeforeReturn: 'Arrival date must be before or equal to return date',
    returnAfterDeparture: 'Return date must be after or equal to departure date',
  },
  form: {
    codeAuto: 'Auto-generated after save',
    refCodePlaceholder: 'Enter reference code',
    productTypePlaceholder: 'Enter product type',
    customerNamePlaceholder: 'Enter customer name',
    fromWarehousePlaceholder: 'From warehouse',
    toWarehousePlaceholder: 'To warehouse',
    fromPortPlaceholder: 'Enter from port',
    toPortPlaceholder: 'Enter to port',
    shippingLinePlaceholder: 'Enter shipping line',
    shippingNamePlaceholder: 'Enter shipping name',
    companyNamePlaceholder: 'Enter company name',
    agencyPlaceholder: 'Enter agency',
    sealCnPlaceholder: 'Enter seal CN',
    sealVnPlaceholder: 'Enter seal VN',
    notesOptional: 'Enter notes (optional)',
    departureDatePlaceholder: 'Departure date',
    arrivalDatePlaceholder: 'Arrival date',
    returnDatePlaceholder: 'Return date',
  },
  fields: {
    code: 'Container code',
    refCode: 'Reference code',
    shippingMethod: 'Shipping method',
    closingDate: 'Closing date',
    departureDate: 'Departure date',
    arrivalDate: 'Arrival date',
    returnDate: 'Return date',
    deliveryDate: 'Delivery date',
    fromPort: 'From port',
    toPort: 'To port',
    status: 'Status',
    notes: 'Notes',
    fromWarehouseId: 'From warehouse',
    toWarehouseId: 'To warehouse',
    agency: 'Agency',
    sealCn: 'Seal CN',
    sealVn: 'Seal VN',
    productType: 'Product type',
    customerName: 'Customer name',
    shippingLine: 'Shipping line',
    shippingName: 'Shipping name',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    companyName: 'Company name',
    shipping: 'Shipping details',
    actions: 'Actions',
    fromWarehouse: 'From warehouse',
    toWarehouse: 'To warehouse',
    shippingMethodShort: 'Method',
  },
  fieldGroups: {
    basicInfo: 'Basic Information',
    warehouseInfo: 'Warehouse Information',
    shippingInfo: 'Shipping Information',
    sealInfo: 'Seal Information',
    additionalInfo: 'Additional Information',
    scheduleInfo: 'Schedule Information',
  },
  searchCode: {
    label: 'Search by code or reference code',
    placeholder: 'Enter container code or reference code',
  },
  statuses: {
    NEW: 'Newly created',
    LOADING: 'Loading',
    CLOSED: 'Closed',
    DEPARTED: 'Departed',
    ARRIVED: 'Arrived',
    RETURNED: 'Returned',
    UNLOADING: 'Unloading',
    DONE: 'Done',
    DELETED: 'Deleted',
  },
  tabs: {
    overview: 'Overview',
    listTheShipments: 'List the shipments',
    listTheShipmentsTooltip: 'Only the new or loading container can be listed the shipments',
    sealInfo: 'Seal Information',
    shipmentsDraft: 'Loading',
    shipmentsClosed: 'Shipments (closed)',
  },
  totals: {
    total: 'Total',
    weight: 'Total weight',
    volume: 'Total volume',
    shipments: 'Total shipments',
    selectedShipments: 'Selected shipments',
  },
  buttons: {
    load: 'Load',
    submit: 'Submit',
    confirm: 'Confirm',
    save: 'Save',
    dragAndDrop: 'Drag and drop',
  },
}
